import * as Yup from 'yup';
import { FormFieldConfig } from '../../types/formField.types';
import { documentApi } from '../../api/accountsApi';
import {
  createdAtField,
  createdByField,
  updatedAtField,
  updatedByField,
} from '../../utils/formFields';
import {
  getFormFields,
  getInitialValues,
  getTableColumns,
  getValidationSchema,
} from '../../utils/fieldConfigHelpers';
import { documentTypeOptions } from '../../utils/options';

export const documentFieldConfig: FormFieldConfig[] = [
  {
    name: 'files',
    label: 'Files',
    type: 'file',
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    multiple: true,
    accept: '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx',
    allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx'],
    maxFileSizeMB: 10,
    showOn: ['create', 'edit', 'view'],
    getInitialValue: () => [],
    infoMessage:
      'Allowed: PDF, JPG, JPEG, PNG, DOC, DOCX, XLS, XLSX. Max size: 10MB each. On edit, uploading files updates the stored files.',
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    yup: Yup.string().trim(),
    getInitialValue: (data) => data?.name || '',
    table: { minWidth: 220 },
    example: 'Invoice FY26-001',
  },
  {
    name: 'type',
    label: 'Type',
    type: 'select',
    options: documentTypeOptions,
    yup: Yup.string().oneOf(['', ...documentTypeOptions.map((opt) => String(opt.value))]),
    getInitialValue: (data) => data?.type || '',
    table: { minWidth: 180 },
    example: 'Invoice',
  },
  createdAtField(),
  updatedAtField(),
  createdByField(),
  updatedByField(),
];

export const documentFormFields = getFormFields(documentFieldConfig);
export const documentFormSchema = getValidationSchema(documentFieldConfig);
export const documentFormInitialValues = (data: any): any =>
  getInitialValues(documentFieldConfig, data);

export const documentTableColumns = getTableColumns(documentFieldConfig);

export const documentConfig = {
  entityName: 'Document',
  redirectPath: '/master-data/documents',
  documentTableColumns,
  api: documentApi,
};
